import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { AirlineData, AirportData, HeadingLevel } from "@/core/types/types";
import Field from "@/core/components/Field";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";
import { fields, FieldName } from "./fields";
import { parseISO } from "date-fns";
import { useEffect, useState } from "react";

interface FlightSummaryEditProps {
  departureAirport: AirportData;
  arrivalAirport: AirportData;
  departureDate: string;
  airline: AirlineData;
  customerGender: string;
  customerFirstName: string;
  customerLastName: string;
  customerEmail: string;
  customerIsMinor: boolean;
  numberOfPassengers: number;
}

const FlightSummaryEdit = ({
  departureAirport,
  arrivalAirport,
  departureDate,
  airline,
  customerGender,
  customerFirstName,
  customerLastName,
  customerEmail,
  customerIsMinor,
  numberOfPassengers,
}: FlightSummaryEditProps) => {
  const [dynamicHeight, setDynamicHeight] = useState(window.innerHeight - 170);

  useEffect(() => {
    const handleResize = () => {
      setDynamicHeight(window.innerHeight - 170);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Box
      px={2}
      my={10}
      height={dynamicHeight}
      overflow="scroll"
      className="flightSummaryEdit"
    >
      <Box mb={2}>
        <Typography variant={HeadingLevel.H2}>
          {t("flightInformation.label")}
        </Typography>
      </Box>

      <Box display="flex" mb={2}>
        <Box mr={1} mt={1} width={1}>
          <Field field={fields[FieldName.Airline]} initialValue={airline} />
        </Box>

        <Box mt={-1} width={1}>
          <Field
            field={fields[FieldName.DepartureDate]}
            initialValue={parseISO(departureDate)}
          />
        </Box>
      </Box>

      <Box mb={2}>
        <Field
          field={fields[FieldName.DepartureAirport]}
          initialValue={departureAirport}
        />
      </Box>

      <Box mb={2}>
        <Field
          field={fields[FieldName.ArrivalAirport]}
          initialValue={arrivalAirport}
        />
      </Box>

      <Box mb={1}>
        <Field
          field={fields[FieldName.NumberOfPassengers]}
          initialValue={numberOfPassengers}
        />
      </Box>

      <Box my={2}>
        <Typography variant={HeadingLevel.H2}>
          {t("contactInformation.label")}
        </Typography>
      </Box>

      <Field
        field={fields[FieldName.CustomerGender]}
        initialValue={customerGender}
      />

      <Box display="flex" mt={2}>
        <Box mr={1} width={1}>
          <Field
            field={fields[FieldName.CustomerFirstName]}
            initialValue={customerFirstName}
          />
        </Box>

        <Field
          field={fields[FieldName.CustomerLastName]}
          initialValue={customerLastName}
        />
      </Box>

      <Box>
        <Field
          field={fields[FieldName.CustomerEmail]}
          initialValue={customerEmail}
        />
        <Field
          field={fields[FieldName.CustomerIsMinor]}
          initialValue={customerIsMinor}
        />
      </Box>
    </Box>
  );
};

export { FlightSummaryEdit };
